import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { SentimentReportTypeEnum } from '../../../../common/enum/sentiment/sentiment-report-type.enum';

export interface SelfSentimentReportEntityProps {
  localDate: Date;
  reportType: SentimentReportTypeEnum;
  score: Number;
}

export class SelfSentimentReportEntity extends Entity<SelfSentimentReportEntityProps> {
  protected _id: string;
  static create(
    props: SelfSentimentReportEntityProps,
    entityId?: string
  ): SelfSentimentReportEntity {
    const id = entityId || v4();
    const entity = new SelfSentimentReportEntity({
      id,
      props,
    });
    return entity;
  }
  public validate(): void {}

  get localDate(): Date {
    return new Date(this.props.localDate.setUTCHours(0, 0, 0, 0));
  }
  get reportType(): SentimentReportTypeEnum {
    return this.props.reportType;
  }
  get score(): Number {
    return this.props.score;
  }
  get percentageOfTotal(): Number {
    return 100;
  }
}
